import type { Program, ProgramActivityContentObjectList } from 'models';
import { Attachments } from 'features/attachments';
import { ActivityContent } from '../activity-content';
import { Footer } from '../footer';
import { LongTextContent } from '../long-text-content';
import { ProgramTimelineItemHeader } from '../program-timeline-item-header';

type P = {
  'data-test-id'?: string;
  item: ProgramActivityContentObjectList;
  program: Program;
};

/**
 * @deprecated AI-generated code, not reviewed. Needs revision before further use — do not use as a reference or pattern to follow.
 */
const ProgramActivityTimelineItem = ({ 'data-test-id': dataTestId, item, program }: P) => {
  const isProgramPublished = program.status === 'published';

  return (
    <div data-test-id={dataTestId}>
      <ProgramTimelineItemHeader item={item} program={program} />

      <LongTextContent item={item} onCreateOrder={() => undefined} />

      <ActivityContent item={item} program={program} />

      <Attachments attachments={item.attachments} />

      <Footer isProgramPublished={isProgramPublished} item={item} program={program} />
    </div>
  );
};

export default ProgramActivityTimelineItem;
